import axios from 'axios';
import { useContext, useEffect } from 'react';
import SessionContext from '../../../library/Core/SessionContext';

const HandleVibgyorLogin = ({ pageTitle }: any) => {
    document.title = pageTitle;

    const { sessionState, sessionDispatch } = useContext(SessionContext);

    useEffect(() => {
        
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const token = urlParams.get('token');
        const student_url_key = urlParams.get('student_url_key');
        const loginUrl = `${process.env.REACT_APP_APP_BASE_URL}/user/vibgyor/login`;
        const error = urlParams.get('error');

        if (error != undefined) {
            window.location.href = loginUrl;
            return;
        }

        if (!token) {
            console.error('Token not found');
            window.location.href = loginUrl;
            return;
        }

        // console.log("Token:", token);
        // console.log("Student URL Key:", student_url_key);

        const payload = token?.split('.')[1];
        const decoded = JSON.parse(atob(payload?? ''));

        const fetchAccessToken = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/admin/get-vibgyor-user-data`, { data : decoded, student_url_key });

                if (response.data.success) {
                    const { firstName, lastName, phoneNumber, studentData, matched } = response.data;
                    
                        localStorage.setItem('firstName', firstName);
                        localStorage.setItem('lastName', lastName);
                        localStorage.setItem('phoneNumber', phoneNumber);
                        localStorage.setItem('studentData', JSON.stringify(studentData));
                        localStorage.setItem('vibgyorUserLoggedIn', '1');
                        localStorage.setItem('matched', matched ? '1' : '0');
                        window.location.href = `${process.env.REACT_APP_APP_BASE_URL}/keycloak-student-selection`;
                    
                } else {
                    window.location.href = loginUrl;
                }
            } catch (error) {
                console.error(error);
                window.location.href = loginUrl;
            }
        };

        fetchAccessToken();
    }, [sessionDispatch]);

    return null;
};

export default HandleVibgyorLogin;
